import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { BaseStorageService } from '@y42/services/storage';

@Injectable({
  providedIn: 'root',
})
export class UserScopeStorageService extends BaseStorageService {
  constructor() {
    super(`${environment.url.frontend_storage_api}/my-storage`);
  }
}
